import React, { useEffect, useState } from "react";

const DeviceContext = React.createContext();
export default DeviceContext;

const COMPACT_MIN_SIZE = 0;
const COMPACT_MAX_SIZE = 599;
const MEDIUM_MIN_SIZE = COMPACT_MAX_SIZE + 1;
// const MEDIUM_MAX_SIZE = 959;
const MEDIUM_MAX_SIZE = 1023;
const EXPANDED_MIN_SIZE = MEDIUM_MAX_SIZE + 1;
const EXTENDED_MIN_SIZE = 1440;

export const DeviceProvider = (props) => {
  const getDeviceMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  };

  const getDeviceCompact = () => {
    return window.innerWidth <= COMPACT_MAX_SIZE &&
      window.innerWidth >= COMPACT_MIN_SIZE
      ? true
      : false;
  };

  const getDeviceMedium = () => {
    return window.innerWidth >= MEDIUM_MIN_SIZE &&
      window.innerWidth <= MEDIUM_MAX_SIZE
      ? true
      : false;
  };

  const getDevicePortrait = () => {
    return window.innerWidth < window.innerHeight ? true : false;
  };

  const getDeviceLandscape = () => {
    return window.innerWidth > window.innerHeight ? true : false;
  };

  const getDeviceRatio = () => {
    return Number((window.innerHeight / window.innerWidth).toFixed(2));
  };

  const getDeviceExpanded = () => {
    return (
      window.innerWidth >= EXPANDED_MIN_SIZE &&
      window.innerWidth < EXTENDED_MIN_SIZE
    );
  };

  const getDeviceExtended = () => {
    return window.innerWidth >= EXTENDED_MIN_SIZE;
  };

  const [windowWidth, setWindowWidth] = useState({ width: window.innerWidth });
  const [windowHeight, setWindowHeight] = useState({
    height: window.innerHeight,
  });

  const [deviceRatio, setDeviceRatio] = useState(getDeviceRatio());
  const [isDeviceCompact, setIsDeviceCompact] = useState(getDeviceCompact());
  const [isDeviceMedium, setIsDeviceMedium] = useState(getDeviceMedium());
  const [isDeviceExpanded, setIsDeviceExpanded] = useState(getDeviceExpanded());
  const [isDeviceExtended, setIsDeviceExtended] = useState(getDeviceExtended());
  const [isDeviceMobile, setIsDeviceMobile] = useState(getDeviceMobile());
  const [isDevicePortrait, setIsDevicePortrait] = useState(getDevicePortrait());
  const [isDeviceLandscape, setIsDeviceLandscape] =
    useState(getDeviceLandscape());

  useEffect(() => {
    // updateDimensions();
    computeWindowSizeClasses();

    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  const updateDimensions = () => {
    setIsDeviceCompact(getDeviceCompact());
    setIsDeviceMedium(getDeviceMedium());
    setIsDeviceMobile(getDeviceMobile());
    setIsDevicePortrait(getDevicePortrait());
    setIsDeviceLandscape(getDeviceLandscape());
    setIsDeviceExpanded(getDeviceExpanded());
    setIsDeviceExtended(getDeviceExtended());
    setDeviceRatio(getDeviceRatio());
    computeWindowSizeClasses();
  };

  const computeWindowSizeClasses = () => {
    // Get window width and height in dp
    const dpi = window.devicePixelRatio;
    const widthDp = window.innerWidth;
    const heightDp = window.innerHeight;

    // Compute width window size class
    const WindowWidthClass = {
      compact: false,
      medium: false,
      expanded: false,
      extended: false,
    };
    if (widthDp < 600) {
      WindowWidthClass.compact = true;
    } else if (widthDp < 840) {
      WindowWidthClass.medium = true;
    } else if (widthDp < 1280) {
      WindowWidthClass.expanded = true;
    } else {
      WindowWidthClass.extended = true;
    }

    // Compute height window size class

    const WindowHeightClass = {
      compact: false,
      medium: false,
      expanded: false,
      extended: false,
    };
    if (heightDp < 480) {
      WindowHeightClass.compact = true;
    } else if (heightDp < 900) {
      WindowHeightClass.medium = true;
    } else if (heightDp < 1280) {
      WindowHeightClass.expanded = true;
    } else {
      WindowHeightClass.expanded = true;
    }

    setWindowWidth({ width: window.innerWidth, ...WindowWidthClass });
    setWindowHeight({ height: window.innerHeight, ...WindowHeightClass });
  };

  return (
    <DeviceContext.Provider
      value={{
        isDeviceMedium,
        isDevicePortrait,
        isDeviceLandscape,
        isDeviceMobile,
        isDeviceExpanded,
        isDeviceExtended,
        isDeviceCompact,
        windowWidth,
        windowHeight,
        deviceRatio,
      }}
    >
      {props.children}
    </DeviceContext.Provider>
  );
};
